import { Grid } from "@mui/material";

import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";

const initialValues = {
  roundIds: [],
};

export const LotteryTokenSearchForm = () => {
  return (
    <SearchWithFilters initialValues={initialValues}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid size={{ xs: 12 }}>
          <EntityInput multiple name="roundIds" controller="lottery/rounds" />
        </Grid>
      </Grid>
    </SearchWithFilters>
  );
};
